import axios from 'axios';

// cloud.seatable.io
// const SEATABLE_BASE_URL = 'https://cloud.seatable.io/api-gateway/api/v2';
// const SEATABLE_BASE_ID = '9761fc01-fb43-46a4-bb2e-62eb0b900a30';
// const SEATABLE_BASE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NjE0NjUxOTQsImR0YWJsZV91dWlkIjoiOTc2MWZjMDEtZmI0My00NmE0LWJiMmUtNjJlYjBiOTAwYTMwIiwicGVybWlzc2lvbiI6InIiLCJvcmdfaWQiOjY2ODY2LCJvd25lcl9pZCI6IjRmNjI2OWNmMmFmYTQ3OGNiMzAzMTRmYzUxNTQ3ZmQ2QGF1dGgubG9jYWwiLCJhcHBfbmFtZSI6Ind3d19hbGx0ZWFtIiwidXNlcm5hbWUiOiIiLCJpZF9pbl9vcmciOiIiLCJ1c2VyX2RlcGFydG1lbnRfaWRzX21hcCI6eyJjdXJyZW50X3VzZXJfZGVwYXJ0bWVudF9pZHMiOltdLCJjdXJyZW50X3VzZXJfZGVwYXJ0bWVudF9hbmRfc3ViX2lkcyI6W119fQ.82T1ne0XoaEGspep4sHDwSEzS1uD48BhG_8I6oxDkRQ';

// seatable.allteam.com
const SEATABLE_ACCOUNT_TOKEN = 'c0fb51089d9e4876e88e9115828829eec3a5cb95';
const SEATABLE_WORKSPACE_ID = 1;
const SEATABLE_WORKSPACE_URL = 'https://seatable.allteam.com/api/v2.1/workspace';

const SEATABLE_BASE_NAME = 'Superager Pinak'
const SEATABLE_BASE_URL = 'https://seatable.allteam.com/api-gateway/api/v2';
const SEATABLE_BASE_ID = '2612cacf-0d22-41d2-a81e-dce5069616c5';
const SEATABLE_BASE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NzI5NDczMjMsImR0YWJsZV91dWlkIjoiMjYxMmNhY2YtMGQyMi00MWQyLWE4MWUtZGNlNTA2OTYxNmM1IiwicGVybWlzc2lvbiI6InJ3Iiwib3JnX2lkIjotMSwib3duZXJfaWQiOiJmZGM2ZWJlYzNmNmU0ZDc5YmFjNmFiNDZhNzRmYmQ2ZkBhdXRoLmxvY2FsIiwidXNlcm5hbWUiOiJmZGM2ZWJlYzNmNmU0ZDc5YmFjNmFiNDZhNzRmYmQ2ZkBhdXRoLmxvY2FsIiwidXNlcl9kZXBhcnRtZW50X2lkc19tYXAiOnsiY3VycmVudF91c2VyX2RlcGFydG1lbnRfaWRzIjpbXSwiY3VycmVudF91c2VyX2RlcGFydG1lbnRfYW5kX3N1Yl9pZHMiOltdfSwiaWRfaW5fb3JnIjoiIn0.d9p4djlapb2uGJdAgtAoZ6MzY7cgIX5l_qY2Q8CUHfc","dtable_uuid":"2612cacf-0d22-41d2-a81e-dce5069616c5';

export async function getBaseToken() {
  try {
    const response = await axios.get(`${SEATABLE_WORKSPACE_URL}/${SEATABLE_WORKSPACE_ID}/dtable/${SEATABLE_BASE_NAME}/access-token/?exp=1d`, 
      {
        headers: {
        'Authorization': `Token ${SEATABLE_ACCOUNT_TOKEN}`,
        'Content-Type': 'application/json'
        }
    });
    
    return response.data.access_token;
  } catch (error) {
    console.error('Error fetching Base Token:', error);
    throw error;
  }
}

export async function execSeatableSql(sql) {
    try {
      var baseToken = sessionStorage.getItem('SEATABLE_BASE_TOKEN') || '';
      if (baseToken === '') {
        baseToken = await getBaseToken();
        sessionStorage.setItem('SEATABLE_BASE_TOKEN', baseToken);
      }

      const response = await axios.post(`${SEATABLE_BASE_URL}/dtables/${SEATABLE_BASE_ID}/sql/`,
        {
            'sql': sql,
            'convert_keys': true
        }, 
        {
          headers: {
            'Authorization': `Token ${baseToken}`,
            'accept': 'application/json',
            'content-type': 'application/json'
        }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

export async function getTableRows(tableName) {
  try {
    const response = await axios.get(`${SEATABLE_BASE_URL}/dtables/${SEATABLE_BASE_ID}/rows/?table_name=${tableName}`, {
      headers: {
        'Authorization': `Token ${SEATABLE_BASE_TOKEN}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

function seaTable() {
    return <div>Seatable Helper Functions</div>
}

export default seaTable;

/*
# https://api.seatable.com/reference/getaccounttokenfromusername
# Request Account Token

curl --request POST \
     --url https://seatable.allteam.com/api2/auth-token/ \
     --header 'accept: application/json' \
     --header 'content-type: application/x-www-form-urlencoded' \
     --data username=marketingallteam@gmail.com \
     --data password=Seatable@102

# Response Account Token
{
  "token": "0c943ecd10ad2ca5954a2a914edababe78fd3223"
}

# https://api.seatable.com/reference/getbasetokenwithaccounttoken
# Request Base Token

curl --request GET \
     --url 'https://seatable.allteam.com/api/v2.1/workspace/1/dtable/Superager%20Pinak/access-token/?exp=30d' \
     --header 'accept: application/json' \
     --header 'authorization: Bearer 0c943ecd10ad2ca5954a2a914edababe78fd3223'

# Response Base Token
{
  "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NzM4MzQ3ODQsImR0YWJsZV91dWlkIjoiMGMzYmVjNjQtZGJhYy00NzhiLWE2NzItY2M5NGIxZTY4MzAzIiwicGVybWlzc2lvbiI6InJ3Iiwib3JnX2lkIjotMSwib3duZXJfaWQiOiJiYWExZGNhMGE5YzM0NmJjODI3ZTIwNTdjMzA4ODU1OEBhdXRoLmxvY2FsIiwidXNlcm5hbWUiOiJiYWExZGNhMGE5YzM0NmJjODI3ZTIwNTdjMzA4ODU1OEBhdXRoLmxvY2FsIiwidXNlcl9kZXBhcnRtZW50X2lkc19tYXAiOnsiY3VycmVudF91c2VyX2RlcGFydG1lbnRfaWRzIjpbXSwiY3VycmVudF91c2VyX2RlcGFydG1lbnRfYW5kX3N1Yl9pZHMiOltdfSwiaWRfaW5fb3JnIjoiIn0.CcEn5zlMLjnDTw0Sr5PH_rRZpPH2JilVrNB5dpTVblA",
  "dtable_uuid": "0c3bec64-dbac-478b-a672-cc94b1e68303"
}
*/